import React, { useEffect } from 'react';
import { isEmpty } from 'lodash/fp';
import { Content } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { getClientFormFields } from '../../../redux/selectors/client';
import { fetchClientColumns } from '../../../redux/sagas/client/routines';
import * as PERMISSIONS from '../../../constants/permissions/guest';
import { guestsBasePath } from '../../Paths';
import history from '../../history';
import { modifyAccess } from '../../../helpers/permission';
import GuestForm from '../../../components/guest/Form';
import AccessDenied from '../../../components/AccessDenied';
import AccessControl from '../../../components/AccessControl';
import PageLayout from '../../../components/guest/PageLayout';
import PageHeader from '../../../components/PageHeader';
import CustomBreadcrumb from '../../../components/Breadcrumb';

export default () => {
  const dispatch = useDispatch();
  const formFields = useSelector(getClientFormFields);

  const handleCancel = () => {
    history.goBack();
  };

  useEffect(
    () => {
      if (isEmpty(formFields)) dispatch(fetchClientColumns());
    },
    [formFields]
  );

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={modifyAccess(PERMISSIONS.MODULE)}
        fallback={<AccessDenied />}
      >
        <CustomBreadcrumb
          items={[
            {
              path: guestsBasePath,
              label: 'Guests'
            },
            { label: 'Create' }
          ]}
        />

        <PageHeader title="Create Guest" />
        <Content style={{ marginTop: 0 }}>
          <GuestForm
            data={{}}
            formFields={formFields}
            onCancel={handleCancel}
          />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
